import axios from 'axios';
import constants from '../constants';

const ADMIN_PATH = constants.urlPrefix + '/api/admin';

const removeBlankDesigns = () => axios.get(ADMIN_PATH + '/removeBlankDesigns');

const removeStaleRevisions = () => axios.get(ADMIN_PATH + '/removeStaleRevisions');

const removeOldDeletedDesigns = () => axios.get(ADMIN_PATH + '/removeOldDeletedDesigns');

const getStats = () => axios.get(ADMIN_PATH + '/stats/data');


function removeUploads(member) {
  return axios.post(ADMIN_PATH + '/removeUploads', {member});
}

export default {
  getStats,
  removeBlankDesigns,
  removeStaleRevisions,
  removeOldDeletedDesigns,
  removeUploads
}
